export default __webpack_public_path__ + "static/media/clearly-rated.e51d653.8af1a1f3.svg";